/**
 * This ReportType Enum is going to be used for the new report generation tooling.
 */
exports.ByName = {
  TransferPricingGlobalGuide: { Id: 1, Name: 'TransferPricingGlobalGuide', Localization: 'reports.transfer_pricing_global_guid' },
  EduRDEstimatorTool: { Id: 2, Name: 'EduRDEstimatorTool', Localization: 'reports.edu_rd_estimator_tool' },
  RAndDGlobalGuide: { Id: 3, Name: 'RAndDGlobalGuide', Localization: 'reports.r_and_d_global_guide' },
  TPIQRiskAssessmentTool: { Id: 4, Name: 'TPIQRiskAssessmentTool', Localization: 'reports.tpiq_risk_assessment' }
};

exports.ById = {
  1: { Id: 1, Name: 'TransferPricingGlobalGuide', Localization: 'reports.transfer_pricing_global_guid' },
  2: { Id: 2, Name: 'EduRDEstimatorTool', Localization: 'reports.edu_rd_estimator_tool' },
  3: { Id: 3, Name: 'RAndDGlobalGuide', Localization: 'reports.r_and_d_global_guide' },
  4: { Id: 4, Name: 'TPIQRiskAssessmentTool', Localization: 'reports.tpiq_risk_assessment' }
};
